import {
  StreamlineIcon,
  type StreamlineIconProps,
} from '../streamlineIcon/StreamlineIcon';
import { SmileySad1 as Svg } from './svgs/SmileySad1.svg';

export const SmileySad1 = (props: StreamlineIconProps) => (
  <StreamlineIcon {...props}>
    <Svg />
  </StreamlineIcon>
);
